import { getSelectSchema, getPercentSchema } from 'src/compass/shared/schemas';
import * as Yup from 'yup';

const isPopulated = (row: any) => row?.sourceEmployeeId != null || row?.sourceId != null;

/*
  Account Sources on an account as-of, splitting the Source Type's rate between them. There
  is no cap on how many. Shared by the CME and LRP account schemas; the same rules are
  enforced server-side in AccountAsOfSourceValidation, since a direct PUT never sees this.
*/
export const AsOfSources = Yup.array()
  .of(
    Yup.object().shape(
      {
        // Both-or-neither per row. rowCountMode={0} never auto-appends a blank row, but a
        // user can add one and fill in only half of it.
        sourceEmployeeId: Yup.mixed().when('sourceId', {
          is: (sourceId: any) => sourceId != null,
          then() {
            return getSelectSchema('', 'Required when "Type" is entered');
          },
          otherwise(schema) {
            return schema.notRequired();
          },
        }),
        sourceId: Yup.mixed().when('sourceEmployeeId', {
          is: (sourceEmployeeId: any) => sourceEmployeeId != null,
          then() {
            return getSelectSchema('', 'Required when "Source Employee" is entered');
          },
          otherwise(schema) {
            return schema.notRequired();
          },
        }),
        splitPercent: Yup.mixed().when(['sourceEmployeeId', 'sourceId'], {
          is: (sourceEmployeeId: any, sourceId: any) =>
            sourceEmployeeId != null || sourceId != null,
          then() {
            return getPercentSchema('Split%');
          },
          otherwise(schema) {
            return schema.notRequired();
          },
        }),
      },
      [['sourceId', 'sourceEmployeeId']]
    )
  )
  .test(
    'unique-source',
    'Source Employee and Type must be unique',
    (rows) => {
      const populated = (rows ?? []).filter(isPopulated);
      const pairs = populated.map((r: any) => `${r.sourceEmployeeId}-${r.sourceId}`);
      return new Set(pairs).size === pairs.length;
    }
  )
  .test('total-100', 'Split % must total 100', (rows) => {
    const populated = (rows ?? []).filter(isPopulated);
    if (populated.length === 0) return true;
    const total = populated.reduce((sum: number, r: any) => sum + Number(r.splitPercent ?? 0), 0);
    // tolerate float noise from a 33.333/66.667 style split
    return Math.abs(total - 100) < 0.0005;
  });

export default AsOfSources;
